import { TRIAL_BALANCE_SCALING_OPTIONS } from 'constants/feature/statement-creation-constants';
import baseModel from 'models/base-model';

export default class TrialBalanceThresholdScaling extends baseModel({
  data: {
    threshold: '2',
    scaling: TRIAL_BALANCE_SCALING_OPTIONS[0],
  },
}) {
  setThreshold(val) {
    return this.merge({
      data: {
        ...this.data,
        threshold: val,
      },
    });
  }

  setScaling(val) {
    return this.merge({
      data: {
        ...this.data,
        scaling: val,
      },
    });
  }

  get threshold() {
    return this.data.threshold;
  }

  get scaling() {
    return this.data.scaling;
  }
}
